import { breakpoint, colors, fontSize, fontWeight, mediaQueryHelper, spacing } from '@offerzen/pinata'
import { css } from '@emotion/css'

const styles = {
  title: css({
    color: colors.oxfordBlue,
    fontSize: fontSize.medium,
    fontWeight: fontWeight.bold,
    lineHeight: '19px',
    marginTop: 0,
    marginBottom: spacing.default,

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.default,
    },
  }),

  count: css({
    color: colors.jumbo,
    fontSize: fontSize.default,
    lineHeight: '18px',
    fontWeight: fontWeight.light,
    whiteSpace: 'nowrap',

    [mediaQueryHelper(breakpoint.phone)]: {
      fontSize: fontSize.small,
    },
  }),
}

export default styles
